export const TOTALEMPLOYEES = [
    { value: '1-10', label: '1-10' },
    { value: '11-50', label: '11-50' },
    { value: '51-100', label: '51-100' },
    { value: '101-250', label: '101-250' },
    { value: '251-500', label: '251-500' },
    { value: '501-750', label: '501-750' },
    { value: '751-100', label: '751-100' },
    { value: '1000+', label: '1000+' },
];

export const VALUESTATUS = {
    CREATED : "created",
    DELETED : "deleted" ,
    UPDATED : "updated",
    PENDINGDELETE : "pendingdelete",
    PUBLISHED : "published"
}

export const BEHAVIORMOCKDATA = [
    {
        id : "bh_1",
        title: "Adaptable",
        weight: 10,
        description: "Ability to adjust to new situations, challenges, and environments with ease. It involves being flexible, open-minded, and resilient in the face of change."
    },
    {
        id : "bh_2",
        title: "Flexible",
        weight: 10,
        description: "Ability to adjust to new situations, challenges, and environments with ease. It involves being flexible, open-minded, and resilient in the face of change."
    },
]

export const INDUSTRIES = [
    {id: "agricultureandfarming", name: "Agriculture and Farming"},
    {id: "artsentertainmentandrecreation", name: "Arts, Entertainment, and Recreation"},
    {id: "construction", name: "Construction"},
    {id: "education", name: "Education"},
    {id: "energyandutilities", name: "Energy and Utilities"},
    {id: "environmentservices", name: "Environment Services"},
    {id: "financeandinsurance", name: "Finance and Insurance"},
    {id: "foodservices", name: "Food Services"},
    {id: "government", name: "Government"},
    {id: "healthcare", name: "Healthcare"},
    {id: "hospitalityandtourism", name: "Hospitality and Tourism"},
    {id: "manufacturing", name: "Manufacturing"},
    {id: "nonprofitorganizations", name: "Non Profit Organizations"},
    {id: "professionalservices", name: "Professional Services"},
    {id: "realestate", name: "Real Estate"},
    {id: "retail", name: "Retail"},
    {id: "retailtrade", name: "Retail and Trade"},
    {id: "transportationandlogistics", name: "Transportation and Logistics"},
    {id: "wastemanagement", name: "Waste Management"},
    {id: "wholesaletrade", name: "Wholesale Trade"},
]

export const CLIENTTYPE = [
    {id: "associationsandprofessionalorganizations", name: "Associations and Professional Organizations"},
    {id: "contractorsandserviceproviders", name: "Contractors and Service Providers"},
    {id: "distributorsandresellers", name: "Distributors and Resellers"},
    {id: "ecommerceplatforms", name: "E-commerce Platforms"},
    {id: "educationalinstitutions", name: "Educational Institutions"},
    {id: "eventplannersandorganizers", name: "Event Planners and Organizers"},
    {id: "financialinstitutions", name: "Financial Institutions"},
    {id: "franchisees", name: "Franchisees"},
    {id: "governmentagencies", name: "Government Agencies"},
    {id: "healthcareproviders", name: "Healthcare Providers"},
    {id: "hospitalityandtourism", name: "Hospitality and Tourism"},
    {id: "individualconsumersb2c", name: "Individual Consumers (B2C)"},
    {id: "internationalcustomers", name: "International Customers"},
    {id: "largeenterprises", name: "Large Enterprises"},
    {id: "mediaandadvertisingagencies", name: "Media and Advertising Agencies"},
    {id: "nonprofitorganizations", name: "Nonprofit Organizations"},
    {id: "realestatedevelopersandinvestors", name: "Real Estate Developers and Investors"},
    {id: "researchinstitutionsandlaboratories", name: "Research Institutions and Laboratories"},
    {id: "smallandmediumsizedbusinessessmbs", name: "Small and Medium-sized Businesses (SMBs)"},
    {id: "suppliersandvendors", name: "Suppliers and Vendors"},
];

export const ATTRIBUTESMOCKDATA = [
    {   
        id: "att_1",
        name: "Innovative",
        valueID: "",
        questions: [],
        attributesData: {
            description : "Innovative candidates create new technologies, services and business modelas that open up entirely new markets oor solve a problem in a substantially better way.",
            examples: []
        },
        valueID: "",
        version: 0,
        attributeWeight: [],
    }
]
